import { ContractState, DefaultContractActionType } from '@paid-ui/enums/contract';
import { RequiringActionFeatureType, RequiringActionType } from '@paid-ui/enums/requiring-action';

import { contractManager } from '../model';

export const saveDefaultActions = () => {
  const { contractState, statuses, permissions, requiringActions, currentParty } = contractManager;
  const { isPrimeContract, isFundingContract, isDraftContract, isSuperContract } = statuses;
  const {
    canCreateClaim,
    canCreateVariation,
    canSendCommencementNotice,
    canSendCompletionNotice,
    canInviteFunder,
    canInviteQS,
    canRequestLinkedContractsAccess,
    canAbandonContract,
    canTerminateContract,
    canRevokeContract,
    canEditDraftContract,
    canDeleteDraftContract,
    canUploadContract,
    canUpdateFeeStructure,
    canRecallContract,
    canUnjoinContract,
  } = permissions;
  const isContractSubmitted = contractState === ContractState.SUBMITTED && !isDraftContract;

  const hasSubmitClaimRequiringAction = requiringActions.some(
    (action) =>
      action.action === RequiringActionType.SUBMIT_CLAIM &&
      action.featureItemType === RequiringActionFeatureType.CONTRACT,
  );

  contractManager.defaultActions = [
    {
      type: DefaultContractActionType.ACCESS_LINKED_CONTRACTS,
      text: isFundingContract ? 'Access funded contracts' : 'Access subcontracts',
      description: isFundingContract
        ? 'Request access to see all contracts funded under this agreement.'
        : 'Request access to see all purchase orders / subcontracts.',
      prime: true,
      hasIcon: true,
      hidden: !canRequestLinkedContractsAccess,
    },
    {
      type: DefaultContractActionType.HALT_SIGNING_CONTRACT,
      text: 'Halt signing and amend',
      danger: true,
      hidden: !canRevokeContract,
    },
    {
      type: DefaultContractActionType.RECALL_CONTRACT,
      text: 'Recall and edit',
      danger: true,
      hidden: !canRecallContract,
    },
    {
      type: DefaultContractActionType.NEW_CLAIM,
      text: 'Claim',
      hasIcon: true,
      hidden: !canCreateClaim || hasSubmitClaimRequiringAction,
    },
    {
      type: DefaultContractActionType.NEW_VARIATION,
      text: 'Variation',
      hasIcon: true,
      hidden: !canCreateVariation,
    },
    {
      type: DefaultContractActionType.SET_COMMENCEMENT,
      text: 'Notice',
      hasIcon: true,
      hidden: !canSendCommencementNotice,
    },
    {
      type: DefaultContractActionType.SET_COMPLETION,
      text: 'Notice',
      hasIcon: true,
      hidden: !canSendCompletionNotice,
    },
    {
      type: DefaultContractActionType.EDIT_DRAFT,
      text: 'Edit',
      prime: true,
      hidden: !canEditDraftContract,
    },
    {
      type: DefaultContractActionType.DELETE_DRAFT,
      text: 'Delete',
      prime: true,
      danger: true,
      hidden: !canDeleteDraftContract,
    },
  ];

  contractManager.dropdownActions = [
    {
      type: DefaultContractActionType.INVITE_FUNDER,
      text: 'Invite Funder',
      hidden: !canInviteFunder,
    },
    {
      type: DefaultContractActionType.INVITE_QS,
      text: 'Invite Quantity Surveyor',
      hidden: !canInviteQS,
    },
    {
      type: DefaultContractActionType.UPLOAD_SIGNED_CONTRACT,
      text: 'Upload signed contract',
      hidden: !canUploadContract,
    },
    {
      type: DefaultContractActionType.UPDATE_FEE_STRUCTURE,
      text: 'Upload fee structure',
      hidden: !canUpdateFeeStructure,
    },
    {
      type: DefaultContractActionType.UNJOIN_CONTRACT,
      text: 'Leave contract',
      danger: true,
      hidden: !canUnjoinContract,
    },
    {
      type: DefaultContractActionType.TERMINATE_CONTRACT,
      text: 'Terminate contract',
      danger: true,
      hidden: !canTerminateContract,
    },
    {
      type: DefaultContractActionType.ABANDON_CONTRACT,
      text: 'Abandon contract',
      danger: true,
      hidden: !canAbandonContract,
    },
  ];
};
